// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bR_QbXVa","backButton":"OtHPo5Ti","forwardButton":"R9IlMRKg","fullFlexBasis":"DW_2jd_6","page":"x90kLmiV","activePage":"_0P62D0B7","chevron":"fjzEu2mc","dots":"TxL2kOF4"};